module.exports = __webpack_public_path__ + "static/media/our-comp-img-BTD.4b576b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/our-companies/our-comp-img-BTD.png
// module id = 330
// module chunks = 0